export default "__VITE_ASSET__CCXDVmz6__"